import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../appUtils/axiosConfig";

const initialState = {
    isLoading: false,
    error: null,
    addresslist: [],
};

export const addAddress = createAsyncThunk(
    "address/add_address",
    async (addressData, { dispatch, rejectWithValue }) => {
        try {
            const response = await axios.post(`address/add_address.php`, addressData);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to add address");
        }
    }
);

export const getAddressData = createAsyncThunk(
    "address/get_address",
    async (userId, { dispatch, rejectWithValue }) => {
        try {
            dispatch(getAddressDataStart());
            const response = await axios.get(`address/get_address.php?user_id=${userId}`);
            dispatch(getAddressDataSuccess(response?.data));
            return response?.data;
        } catch (error) {
            dispatch(getAddressDataFailure(error.response?.data?.message || "Failed to fetch addresses"));
            return rejectWithValue(error.response?.data?.message || "Failed to fetch addresses");
        }
    }
);

export const removeAddress = createAsyncThunk(
    "address/remove_address",
    async ({ user_id, address_id }, { dispatch, rejectWithValue }) => {

        try {
            const response = await axios.post(`address/delete_address.php?id=${address_id}`);
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed to remove address");
        }
    }
);

export const updateAddress = createAsyncThunk(
    "address/update_address",
    async ({ address_id, addressData }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `address/update_address.php?id=${address_id}`,
                addressData
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Failed to update address"
            );
        }
    }
);


const addressSlice = createSlice({
    name: 'addresses',
    initialState,
    reducers: {
        getAddressDataStart(state, action) {
            state.isLoading = true;
            state.error = null;
            state.addresslist = [];
        },
        getAddressDataSuccess(state, action) {
            state.isLoading = false;
            state.addresslist = action.payload?.addresses || [];
        },
        getAddressDataFailure(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(addAddress.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(addAddress.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addAddress.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(updateAddress.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateAddress.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(updateAddress.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    }
});

export const {
    getAddressDataStart,
    getAddressDataSuccess,
    getAddressDataFailure,
} = addressSlice.actions;

export default addressSlice.reducer;